import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, Palette } from '@core/config/constants';
import { BootScene } from '@core/scenes/BootScene';
import { PreloadScene } from '@core/scenes/PreloadScene';
import { HubScene } from '@scenes/HubScene';
import { MinigameRegistry } from '@core/registry/MinigameRegistry';

/**
 * Construye la configuracion de Phaser. Las escenas de los minijuegos se obtienen
 * dinamicamente del registry, de modo que sumar un minijuego no requiere editar
 * esta configuracion.
 */
export function createGameConfig(parent: string): Phaser.Types.Core.GameConfig {
  const minigameScenes = MinigameRegistry.list().map((definition) => definition.scene);

  return {
    type: Phaser.AUTO,
    parent,
    backgroundColor: Palette.background,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
    },
    input: {
      activePointers: 3,
    },
    scene: [BootScene, PreloadScene, HubScene, ...minigameScenes],
  };
}
